import { h } from '@stencil/core';

const Icon = ({ width = '100%', height = '100%' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 76 59" fill="none" stroke="black" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.0152 38.8795C16.0152 38.8795 13.7667 32.6336 13.0171 31.1345C12.7011 30.5024 12.5174 29.8853 10.5187 28.886C8.51993 27.8866 6.02159 26.1377 5.52193 25.8879C5.02226 25.6381 2.27401 30.385 4.52259 33.3831C6.77118 36.3811 13.2669 39.3791 14.5161 39.8788C15.7653 40.3786 16.7647 40.6284 16.0152 38.8795Z"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.4111 13.1923C16.4111 13.1923 16.2651 12.3968 16.0152 11.897C15.7654 11.3974 13.3631 11.5933 12.9134 11.5933C12.4637 11.5933 11.9141 11.7432 11.9141 12.3928C11.9141 12.8924 11.9641 13.492 11.9641 13.7419C11.9641 13.9917 12.2139 14.5414 12.9634 14.6913C13.7129 14.8412 15.2619 14.9411 15.2619 14.9411"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.5058 15.5906C24.5058 15.5906 24.3558 12.5925 27.204 12.4926C30.0522 12.3927 31.7011 12.4926 33.0502 12.6425C34.3993 12.7924 34.9489 13.5919 34.9989 15.7904"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M28.9528 12.2427C28.4031 12.2427 27.4038 11.8429 27.4038 10.8936C27.4038 9.94424 27.4538 9.34458 27.5037 8.94483C27.5537 8.54508 27.9035 8.04541 28.653 8.04541C29.4025 8.04541 30.6017 8.04541 31.1513 8.04541C31.7509 8.04541 32.1007 8.39516 32.1506 8.84491C32.2578 9.80916 32.3505 10.3939 32.3505 10.9935C32.3505 11.5931 31.9008 12.2927 31.0513 12.2927C30.302 12.2927 28.9528 12.2427 28.9528 12.2427Z"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M70.5115 25.638C70.2616 23.8892 68.9557 21.6861 65.5147 19.3921C62.5166 17.3934 60.2681 14.3953 60.2681 14.3953C57.7697 10.1481 53.7724 4.40183 50.7743 3.65233C47.7762 2.90283 38.0326 2.90283 38.0326 2.90283H38.0009C38.0009 2.90283 28.2572 2.90283 25.2591 3.65233C22.2611 4.40183 18.2636 10.1481 15.7653 14.3953C15.7653 14.3953 13.5168 17.3934 10.5187 19.3921C7.07772 21.6861 5.77181 23.8892 5.52197 25.638"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M72.0105 32.6335C72.0105 32.6335 74.0091 37.1306 73.2596 40.8782C72.5101 44.6258 71.7606 45.1255 71.7606 46.3746C71.7606 47.6238 72.6077 48.869 69.2622 50.372C66.3795 51.6671 55.2713 56.3681 38.0325 56.3681H38.0008C20.762 56.3681 9.63189 51.7147 6.77105 50.372C3.85247 49.0022 4.27264 47.6238 4.27264 46.3746C4.27264 45.1255 3.52314 44.6258 2.77364 40.8782C2.02414 37.1306 4.0228 32.6335 4.0228 32.6335"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M60.0179 38.8795C60.0179 38.8795 62.2664 32.6336 63.016 31.1345C63.332 30.5024 63.5157 29.8853 65.5144 28.886C67.5132 27.8866 70.0115 26.1377 70.5112 25.8879C71.0109 25.6381 73.7591 30.385 71.5105 33.3831C69.2619 36.3811 62.7662 39.3791 61.517 39.8788C60.2678 40.3786 59.2684 40.6284 60.0179 38.8795Z"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M38.0324 43.3765C38.0324 43.3765 44.632 43.4724 50.7741 42.3771C54.2525 41.7569 56.2706 40.8781 57.7696 38.3797C58.4123 37.3085 59.0188 35.6315 59.7683 33.8826C61.0015 31.0053 60.0451 31.317 57.2699 31.6341C48.5255 32.6335 38.0324 32.4796 38.0324 32.4796H38.0007C38.0007 32.4796 27.5075 32.6335 18.7632 31.6341C15.988 31.317 15.0317 31.0053 16.2648 33.8826C17.0143 35.6315 17.6208 37.3085 18.2635 38.3797C19.7625 40.8781 21.7805 41.7569 25.259 42.3771C31.401 43.4724 38.0007 43.3765 38.0007 43.3765H38.0324Z"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M59.722 13.6919C59.9258 14.9871 58.6283 15.2561 57.5196 15.3947C55.5209 15.6446 40.5306 15.8944 38.0323 15.8944H38.0006C35.5022 15.8944 20.5119 15.6446 18.5133 15.3947C17.4046 15.2561 16.1071 14.9871 16.3109 13.6919"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M59.6221 13.1923C59.6221 13.1923 59.7681 12.3968 60.0179 11.897C60.2677 11.3973 62.6701 11.5933 63.1197 11.5933C63.5694 11.5933 64.1191 11.7432 64.1191 12.3928C64.1191 12.8925 64.0691 13.492 64.0691 13.7419C64.0691 13.9917 63.8192 14.5414 63.0697 14.6913C62.3202 14.8412 60.7712 14.9411 60.7712 14.9411"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M53.826 5.6471C53.826 5.6471 52.5269 4.99752 50.6281 4.8976C48.7294 4.79768 42.7333 4.54785 38.0363 4.54785H37.9968C33.2999 4.54785 27.3038 4.79768 25.4049 4.8976C23.5062 4.99752 22.207 5.6471 22.207 5.6471"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M51.5273 15.5906C51.5273 15.5906 51.6773 12.5925 48.8291 12.4926C45.9809 12.3927 44.332 12.4926 42.9829 12.6425C41.6338 12.7924 41.0842 13.5919 41.0342 15.7904"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M47.0804 12.2427C47.63 12.2427 48.6294 11.8429 48.6294 10.8936C48.6294 9.94424 48.5794 9.34458 48.5295 8.94483C48.4795 8.54508 48.1297 8.04541 47.3802 8.04541C46.6307 8.04541 45.4315 8.04541 44.8818 8.04541C44.2822 8.04541 43.9324 8.39516 43.8825 8.84491C43.7753 9.80916 43.6826 10.3939 43.6826 10.9935C43.6826 11.5931 44.1323 12.2927 44.9818 12.2927C45.7312 12.2927 47.0804 12.2427 47.0804 12.2427Z"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M0.936523 18.3576V57.9801H75.1941V18.0806" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M11.1885 1.31714H64.9421" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
};

export default Icon;
